<style lang="less" scoped>
@import '../../../style/common/variable';
.countries {width: 395px;
  .top {text-align: left;height: 40px;
    h3 {font-size: 18px;letter-spacing: 1px;line-height: 40px;margin: 0;
      i {font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}}}
  .bottom {width: 395px;height: 561px;background-color: #eeeeee;
    img {width: 395px;height: 242px;background-color: #00afff;border-radius: 2px;}
    p {width: 363px;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;line-height: 28px;letter-spacing: 1px;color: #08032b;margin: 8px auto;
      span {display: inline-block;text-align: left;}
      .ptop {	font-family: AlibabaPuHuiTi-Regular;font-size: 14px;line-height: 28px;letter-spacing: 1px;color: #08032b;}
      .pbottom {float: right;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;line-height: 20px;letter-spacing: 1px;color: #2776ff;cursor: pointer;}
    }
  }
}
@media screen and (max-width: @max-screen){
  .top{margin-left: 3vw;}
  .bottom{width: 94vw !important; margin-left: 3vw; height: auto !important;
    img{width: 94vw !important;}
    p{width: 94vw !important; margin-left: 3vw;}
  }
}
</style>

<!-- 安进 2021.6.30 国家详情组件 -->
<template>
  <div class="countries">
    <div class="top">
      <h3><i class="iconfont icon-gaikuangtongji"></i>{{ countries }}矿业概况</h3>
    </div>
    <div class="bottom">
      <img :src="Introduce.pic2"/>
      <p>
        <span class="ptop">{{ Introduce.areamemo }}</span>
        <span class="pbottom" @click="DmkyClick(Introduce)">查看更多</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['Introduce'],
  name: '',
  data()
  {
    return {
      ID: null,
      countries: null,
      introduce: {}//国家介绍信息
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.ID = +nval.query.id
        this.getCountrierNane()
      },
      immediate: true
    }
  },
  methods: {
    getCountrierNane()
    {
      switch (this.ID)
      {
      case 2 : this.countries = '中国'
        break
      case 4 : this.countries = '马来西亚'
        break
      case 3 : this.countries = '印度尼西亚'
        break
      case 7 : this.countries = '泰国'
        break
      case 5 : this.countries = '菲律宾'
        break
      case 6 : this.countries = '新加坡'
        break
      case 8 : this.countries = '文莱'
        break
      case 9 : this.countries = '越南'
        break
      case 10 : this.countries = '老挝'
        break
      case 11 : this.countries = '缅甸'
        break
      case 12 : this.countries = '柬埔寨'
        break
      case 13 : this.countries = '东帝汶'
        break
      }
    },
    DmkyClick(Introduce)
    {
      let url = this.$router.resolve({path: '/DmkyDetails', query: {id: Introduce.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Countries.vue